import { WarrantyLogInput, WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

type WarrantyLogUploadFileType = {
  logId: number;
  file: Blob;
};
export const useWarrantyLogUploadFileMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WarrantyLogService.postWarrantyLogUploadFile>>,
      QueryError,
      WarrantyLogUploadFileType,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (input: WarrantyLogUploadFileType) =>
      WarrantyLogService.postWarrantyLogUploadFile(input.logId, { File: input.file }),
    options
  );
